"use client";

/**
 * Platform Insights now lives in components/staff/insights/ — a staff view
 * (overview, people, groups, emails, changes) with a developer view behind a
 * toggle. Kept as the entry point the staff page already imports.
 */
export { InsightsPanel as PlatformInsightsPanel } from "../insights/InsightsPanel";
